<template>
    <div class="layout">
       
        <div class=""></div>
        <div class="layout-content" :class="{ isSHow }">
             <LayoutHeader v-if="isSHow" ref="header" />
            <router-view />
        </div>
        <LayoutFooter v-if="isSHow" />


        <Popup v-model="$store.state.show" position="bottom" round get-container="#app" @closed="handleClose">
            <div class="layout-loading" v-if="$store.state.loading">
                <div class="title">
                    {{ $t('node.progress') }}
                    <img src="../assets/img/node/icon7.png" @click="handleClose" alt="">
                </div>
                <div class="loading">
                    <div class="loader-inner ball-spin-fade-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <div class="desc">{{ $t('node.progress') }}</div>
            </div>
            <div class="layout-claim" v-else>
                <div class="title">
                    {{ $t('node.executionSuccessful') }}
                    <img src="../assets/img/node/icon7.png" @click="handleClose" alt="">
                </div>
                <div class="claim-ok">
                    <img src="../assets/img/node/claim.png" alt="">
                    <div class="title">
                        {{ $t('node.executionSuccessful') }}
                    </div>
                    <!-- <div class="desc">
                        <span>{{ $t('node.at') }}Nexus Chain {{ $t('node.view') }}:0xe7d92</span>
                    </div> -->
                </div>

            </div>
        </Popup>
    </div>

</template>

<script>
import LayoutHeader from './header.vue'
import LayoutFooter from './footer.vue'
import { Overlay, Popup, Loading } from 'vant';
export default {
    name: 'layout',
    components: {
        LayoutHeader,
        Popup,
        LayoutFooter,
        Loading
    },
    computed: {
        isSHow() {
            return ['home',
                'node',
                'exchange',
                'me',
                'release'].includes(this.$route.name)
        }
    },
    mounted(){
            // this.$store.commit('handleShow',true)

    },
    methods: {
        handleClick() {
        },
        handleClose() {
            // 设置true 会显示弹窗
            // this.$store.commit('handleShow',true)
            this.$store.commit('handleShow', false)
        }
    }
}
</script>

<style lang="less">
.layout {
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    max-width: 375px;
    overflow-y: auto;
    overflow-x: hidden;

    .layout-content {
        position: relative;
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow-x: hidden;

        &.isSHow {
            padding-bottom: 82px;

        }
    }
}

.loading-warp {
    position: absolute;


}

.layout-loading {
      padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.loading {
        padding-top: 64px;
        display: flex;
        height: 100px;
        justify-content: center;

        @keyframes ball-spin-fade-loader {
            50% {
                opacity: 0.3;
                -webkit-transform: scale(0.4);
                transform: scale(0.4);
            }

            100% {
                opacity: 1;
                -webkit-transform: scale(1);
                transform: scale(1);
            }
        }

        .ball-spin-fade-loader {
            position: relative;
            margin-left: -15px;
        }

        .ball-spin-fade-loader>div:nth-child(1) {
            top: 25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0s infinite linear;
            animation: ball-spin-fade-loader 1s 0s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(2) {
            top: 17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.12s infinite linear;
            animation: ball-spin-fade-loader 1s 0.12s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(3) {
            top: 0;
            left: 25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.24s infinite linear;
            animation: ball-spin-fade-loader 1s 0.24s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(4) {
            top: -17.04545px;
            left: 17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.36s infinite linear;
            animation: ball-spin-fade-loader 1s 0.36s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(5) {
            top: -25px;
            left: 0;
            -webkit-animation: ball-spin-fade-loader 1s 0.48s infinite linear;
            animation: ball-spin-fade-loader 1s 0.48s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(6) {
            top: -17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.6s infinite linear;
            animation: ball-spin-fade-loader 1s 0.6s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(7) {
            top: 0;
            left: -25px;
            -webkit-animation: ball-spin-fade-loader 1s 0.72s infinite linear;
            animation: ball-spin-fade-loader 1s 0.72s infinite linear;
        }

        .ball-spin-fade-loader>div:nth-child(8) {
            top: 17.04545px;
            left: -17.04545px;
            -webkit-animation: ball-spin-fade-loader 1s 0.84s infinite linear;
            animation: ball-spin-fade-loader 1s 0.84s infinite linear;
        }

        .ball-spin-fade-loader>div {
            background: linear-gradient(133deg, #0DF1D5 2%, #0190D1 98%);
            width: 15px;
            height: 15px;
            border-radius: 100%;
            margin: 2px;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            position: absolute;
        }
    }

    >.desc {
        margin-top: 16px;
        text-align: center;
        letter-spacing: -0.25px;
        font-size: 14px;
        opacity: 0.6;
    }
}

.layout-claim {
    padding: 32px 20px 80px;

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    .claim-ok {
        padding-top: 68px;

        >img {
            width: 120px;
            height: 120px;
            margin: 0 auto;
        }

        >.title {
            font-size: 18px;
            margin-top: 16px;
            text-align: center;
            letter-spacing: -0.25px;
        }

        >.desc {
            font-size: 14px;
            margin-top: 8px;
            letter-spacing: -0.25px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                opacity: 0.6;

            }

            img {
                width: 16px;
                height: 16px;
                margin-left: 7px;
            }
        }
    }

}

.subscription-popup {
    padding: 32px 20px 40px;
    border: 1px solid rgba(255, 255, 255, 0.5);

    >.title {
        display: flex;
        justify-content: space-between;
        line-height: 16px;
        font-size: 16px;

        >img {
            width: 20px;
            height: 20px;
        }
    }

    >.value {
        font-size: 35px;
        letter-spacing: -0.25px;
        line-height: 42px;
        padding: 40px 0 32px;
        text-align: center;
        color: #05B9D0;

        span {
            font-size: 15px;
            margin-left: 8px;
            color: #FFFFFF;
        }
    }

    >.desc {
        box-shadow: -20px 68px 20px 0px rgba(0, 0, 0, 0), -13px 43px 18px 0px rgba(0, 0, 0, 0.01), -7px 24px 15px 0px rgba(0, 0, 0, 0.04), -3px 11px 11px 0px rgba(0, 0, 0, 0.07), -1px 3px 6px 0px rgba(0, 0, 0, 0.08);
        background: conic-gradient(from 103deg at 52% 41%, rgba(249, 249, 249, 0.25) -33deg, rgba(64, 64, 64, 0.25) 11deg, rgba(64, 64, 64, 0.175) 32deg, rgba(255, 255, 255, 0.25) 60deg, rgba(255, 255, 255, 0.25) 108deg, rgba(64, 64, 64, 0.175) 188deg, rgba(249, 249, 249, 0.5) 208deg, rgba(255, 255, 255, 0.25) 287deg, rgba(249, 249, 249, 0.25) 327deg, rgba(64, 64, 64, 0.25) 371deg);
        border-radius: 16px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        >div {
            background: linear-gradient(241deg, #1E1D24 9%, #13121B 78%);
            backdrop-filter: blur(30px);
            border-radius: 16px;
            width: calc(100% - 2px);
            height: calc(100% - 2px);
            border-radius: 16px;
            padding: 16px;

            >div+div {
                margin-top: 16px;
            }

            >div {
                display: flex;
                justify-content: space-between;

                .label {
                    opacity: 0.6;
                    font-size: 14px;
                    letter-spacing: -0.25px;
                }

                .value {
                    letter-spacing: -0.25px;
                    font-size: 14px;
                }
            }
        }
    }

    >.btn {
        background: url('../assets/img/layout/btn1.png') no-repeat;
        background-size: 100% 100%;
        border-radius: 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        height: 48px;
        color: #FFFFFF;
        margin-top: 36px;
    }
}
</style>